// Note shape as consumed by the translation flow (sender is the numeric
// creator; patient=2). Structural so it works with the REST rows.
export type TranslatableNote = {
  id: number | string;
  sender: number;
  note?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

// Replace patient-authored notes (sender===2) with the translated sentences,
// in order. Non-patient notes pass through unchanged.
export const replaceNotesWithArrayValues = (
  notes: TranslatableNote[],
  sentences: string[]
): TranslatableNote[] => {
  let noteIndex = 0;
  const result = [...notes];

  for (let i = 0; i < result.length; i++) {
    if (result[i].sender === 2) {
      result[i] = { ...result[i], note: sentences[noteIndex] };
      noteIndex++;
    }
  }

  return result;
};
